/**
 * @generated SignedSource<<9b75739c5e5433f53a27cef360996f61>>
 * @relayHash d57fe5596a7f6d5bd1d8b4abdf3fb08b
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d57fe5596a7f6d5bd1d8b4abdf3fb08b

import { ConcreteRequest } from 'relay-runtime';
export type CareProviderGroupType = "CHIROPRACTOR" | "DENTIST" | "DOCTOR" | "HOSPITAL" | "NONE" | "NUTRITIONIST" | "PHARMACY" | "PHYSIOTHERAPIST" | "PSYCHOTHERAPIST";
export type CareProviderSearchType = "ADVANCED_SEARCH" | "GENERAL_PRACTITIONER" | "HOSPITAL_ELECTIVE_WITHOUT_SPECIALTY" | "HOSPITAL_ELECTIVE_WITH_SPECIALTY" | "HOSPITAL_EMERGENCY_ROOM" | "MEDICAL_EMERGENCY_OR_PERMANENCE" | "NONE" | "PRESCRIPTION_DOCUMENT" | "SPECIALIST_WITHOUT_SPECIALTY" | "SPECIALIST_WITH_SPECIALTY" | "THERAPY_PRESCRIPTION_NEUROPSYCHOLOGIC_DIAGNOSTIC_DOCUMENT" | "THERAPY_PRESCRIPTION_NUTRITIONAL_COUNSELLING_DOCUMENT" | "THERAPY_PRESCRIPTION_PHYSIOTHERAPY_DOCUMENT" | "THERAPY_PRESCRIPTION_PSYCHOLOGICAL_PSYCHOTHERAPY_DOCUMENT" | "TIME_WINDOW_WITH_REFERRAL_TO" | "TIME_WINDOW_WITH_REFERRED_BY";
export type DayOfWeek = "FRIDAY" | "MONDAY" | "SATURDAY" | "SUNDAY" | "THURSDAY" | "TUESDAY" | "WEDNESDAY";
export type RelationType = "AFFILIATED_WITH" | "BILLS_VIA" | "EMPLOYED_BY";
export type TimeToTreatType = "LATER" | "URGENT" | "WITHIN12H" | "WITHIN14DAYS" | "WITHIN24H" | "WITHIN48H" | "WITHIN6H";
export type WorkingType = "CLOSED" | "HOURLY" | "OPEN24_HOURS";
export type CareProviderSearchInput = {
  excludeRelationTypes?: ReadonlyArray<RelationType> | null;
  searchText: string;
  searchType: CareProviderSearchType;
  specialtyId?: string | null;
  timeToTreatSort?: TimeToTreatType | null;
  top?: number;
};
export type careProviderSearchQuery$variables = {
  language: string;
  searchInput: CareProviderSearchInput;
};
export type careProviderSearchQuery$data = {
  readonly ch_careProviderSearch: {
    readonly results: ReadonlyArray<{
      readonly businessName: string | null;
      readonly careProviderGroupId: string;
      readonly careProviderGroupQuickList: {
        readonly groupType: CareProviderGroupType;
      };
      readonly careProviderSpecialtyTranslations: ReadonlyArray<{
        readonly name: string;
      }>;
      readonly city: string | null;
      readonly country: {
        readonly countryName: string | null;
      } | null;
      readonly countryCode: string | null;
      readonly creditorCodeRegister: string | null;
      readonly detailedSchedule: ReadonlyArray<{
        readonly day: DayOfWeek;
        readonly periods: ReadonlyArray<{
          readonly end: string;
          readonly start: string;
        }> | null;
        readonly workingType: WorkingType;
      }> | null;
      readonly firstName: string | null;
      readonly groupName: string | null;
      readonly highlights: ReadonlyArray<{
        readonly key: string;
        readonly value: string;
      }> | null;
      readonly id: string;
      readonly insuranceCareProviderListIds: ReadonlyArray<string> | null;
      readonly isMedgatePartnerNetworkMember: boolean | null;
      readonly isTakesNewPatients: boolean | null;
      readonly lastName: string | null;
      readonly partyType: string | null;
      readonly postalCode: string | null;
      readonly relationBusinessName: string | null;
      readonly relationFirstName: string | null;
      readonly relationLastName: string | null;
      readonly relationTitle: string | null;
      readonly relationType: string | null;
      readonly streetAddress: string | null;
      readonly title: string | null;
    }>;
  };
};
export type careProviderSearchQuery = {
  response: careProviderSearchQuery$data;
  variables: careProviderSearchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "language"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchInput"
},
v2 = [
  {
    "kind": "Variable",
    "name": "searchInput",
    "variableName": "searchInput"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "businessName",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "careProviderGroupId",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "countryCode",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "city",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "postalCode",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "streetAddress",
  "storageKey": null
},
v13 = [
  {
    "kind": "Variable",
    "name": "language",
    "variableName": "language"
  }
],
v14 = {
  "alias": null,
  "args": (v13/*:: as any*/),
  "kind": "ScalarField",
  "name": "countryName",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "creditorCodeRegister",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "groupType",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isTakesNewPatients",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isMedgatePartnerNetworkMember",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "insuranceCareProviderListIds",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": (v13/*:: as any*/),
  "kind": "ScalarField",
  "name": "groupName",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "relationType",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "partyType",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "relationBusinessName",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "relationFirstName",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "relationLastName",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "relationTitle",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "concreteType": "DaySchedule",
  "kind": "LinkedField",
  "name": "detailedSchedule",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "day",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "workingType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TimePeriod",
      "kind": "LinkedField",
      "name": "periods",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "start",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "end",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "concreteType": "KeyValuePairOfStringAndString",
  "kind": "LinkedField",
  "name": "highlights",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "careProviderSearchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "concreteType": "SearchTextResultOfCareProviderSearchResult",
        "kind": "LinkedField",
        "name": "ch_careProviderSearch",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CareProviderSearchResult",
            "kind": "LinkedField",
            "name": "results",
            "plural": true,
            "selections": [
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              (v5/*:: as any*/),
              (v6/*:: as any*/),
              (v7/*:: as any*/),
              (v8/*:: as any*/),
              (v9/*:: as any*/),
              (v10/*:: as any*/),
              (v11/*:: as any*/),
              (v12/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CountryLookup",
                "kind": "LinkedField",
                "name": "country",
                "plural": false,
                "selections": [
                  (v14/*:: as any*/)
                ],
                "storageKey": null
              },
              (v15/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CareProviderGroup",
                "kind": "LinkedField",
                "name": "careProviderGroupQuickList",
                "plural": false,
                "selections": [
                  (v16/*:: as any*/)
                ],
                "storageKey": null
              },
              (v17/*:: as any*/),
              (v18/*:: as any*/),
              (v19/*:: as any*/),
              (v20/*:: as any*/),
              {
                "alias": null,
                "args": (v13/*:: as any*/),
                "concreteType": "SpecialtyTranslation",
                "kind": "LinkedField",
                "name": "careProviderSpecialtyTranslations",
                "plural": true,
                "selections": [
                  (v21/*:: as any*/)
                ],
                "storageKey": null
              },
              (v22/*:: as any*/),
              (v23/*:: as any*/),
              (v24/*:: as any*/),
              (v25/*:: as any*/),
              (v26/*:: as any*/),
              (v27/*:: as any*/),
              (v28/*:: as any*/),
              (v29/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "careProviderSearchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "concreteType": "SearchTextResultOfCareProviderSearchResult",
        "kind": "LinkedField",
        "name": "ch_careProviderSearch",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CareProviderSearchResult",
            "kind": "LinkedField",
            "name": "results",
            "plural": true,
            "selections": [
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              (v5/*:: as any*/),
              (v6/*:: as any*/),
              (v7/*:: as any*/),
              (v8/*:: as any*/),
              (v9/*:: as any*/),
              (v10/*:: as any*/),
              (v11/*:: as any*/),
              (v12/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CountryLookup",
                "kind": "LinkedField",
                "name": "country",
                "plural": false,
                "selections": [
                  (v14/*:: as any*/),
                  (v3/*:: as any*/)
                ],
                "storageKey": null
              },
              (v15/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CareProviderGroup",
                "kind": "LinkedField",
                "name": "careProviderGroupQuickList",
                "plural": false,
                "selections": [
                  (v16/*:: as any*/),
                  (v3/*:: as any*/)
                ],
                "storageKey": null
              },
              (v17/*:: as any*/),
              (v18/*:: as any*/),
              (v19/*:: as any*/),
              (v20/*:: as any*/),
              {
                "alias": null,
                "args": (v13/*:: as any*/),
                "concreteType": "SpecialtyTranslation",
                "kind": "LinkedField",
                "name": "careProviderSpecialtyTranslations",
                "plural": true,
                "selections": [
                  (v21/*:: as any*/),
                  (v3/*:: as any*/)
                ],
                "storageKey": null
              },
              (v22/*:: as any*/),
              (v23/*:: as any*/),
              (v24/*:: as any*/),
              (v25/*:: as any*/),
              (v26/*:: as any*/),
              (v27/*:: as any*/),
              (v28/*:: as any*/),
              (v29/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "d57fe5596a7f6d5bd1d8b4abdf3fb08b",
    "metadata": {},
    "name": "careProviderSearchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "25d28afa41e7f564d91d10d50168e07c";

export default node;
